import { render, staticRenderFns } from "./order-confirmation-submissions.vue?vue&type=template&id=24b9d166&scoped=true&"
import script from "./order-confirmation-submissions.vue?vue&type=script&lang=js&"
export * from "./order-confirmation-submissions.vue?vue&type=script&lang=js&"
import style0 from "./order-confirmation-submissions.vue?vue&type=style&index=0&id=24b9d166&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b9d166",
  null
  
)

export default component.exports